import { getWithToken, postWithToken } from 'api/network';

export async function GetUnderwrite(txnOppId) {
    const url = `/api/underwrite/workflow/opportunity/${txnOppId}`;
    const response = await getWithToken(url);
    if (response.status === 204) return null; // No underwrite found
    const data = await response.json();
    return data;
}
export async function ViewCrmInfo(txnOppId) {
    const url = `/api/underwrite/workflow/purchasing/viewCrmInfo/${txnOppId}`;
    const response = await postWithToken(url, txnOppId);
    const data = await response.json();
    return data;
  }
export async function FetchAutoPricing(txnOppIds) {
    console.log('fetchautopricing ', txnOppIds);
    const response = await postWithToken(`/api/underwrite/prop/autoPricing`, txnOppIds);
    if (response.ok){
    const data = await response.json();
    console.log('fetchautopricingdata', data);
    return data;
    } else {
        return null;
    }
}

export const GetValuationTypeMetadata = async (txnOppId) => {
  const url = `/api/underwrite/valuations/getValuationTypeMetadata/${txnOppId}`
  const response = await getWithToken(url)
  const data = await response.json()
  return data;
}

export const GetPostAcquisitionValuationsExportData = async (txnOppIds) => {
  const url = '/api/postAcquisitionValuationsExport'
  return await postWithToken(url, txnOppIds)
}

export const GetPricingExportData = async (txnOppIds) => {
  const url = '/api/underwrite/prop/getPricingExport'
  return await postWithToken(url, txnOppIds)
}